// removed by extract-text-webpack-plugin
module.exports = {"letter-box":"letter-box___3zR97","letter-box-flex":"letter-box-flex___36Lno center___2iqBf","letter-box-label":"letter-box-label___2GKdu","show-letter-button":"show-letter-button___2VPUW","company-letter-slidedown":"company-letter-slidedown___3LYa-","company-letter-blockquote":"company-letter-blockquote___3V_m0 h4___kHWTn","take-action-icons":"take-action-icons___2SJ04 center___2iqBf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AmazonStaffLetters/AmazonStaffLetters.css
// module id = 252
// module chunks = 0